import { useContext, useEffect, useState } from "react";
import AuthContext from "../context/AuthContext";
import useCustomFetch from "../hooks/useCustomFetch";
import { useNavigate } from "react-router-dom"; // #POW-22
import DashboardLayout from "../layouts/DashboardLayout";
import ShopTransactionsSentDataGrid from "../components/ShopTransactionsSentDataGrid";
import { Box, Button, CircularProgress, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next"; // #POW-29
import FileDownloadIcon from '@mui/icons-material/FileDownload'; // #POW-30
import { GridFilterModel, GridValidRowModel } from "@mui/x-data-grid"; // #POW-30
import { blue } from "@mui/material/colors"; // #POW-30
import Config from "../Config"; // #POW-30

const TransactionsSentPage = () => {
  const { t } = useTranslation();  // #POW-29
  const auth = useContext(AuthContext)
  const navigate = useNavigate();
  const { isReady } = useContext(AuthContext)
  const customFetch = useCustomFetch()
  const [filterModel, setFilterModel] = useState<GridFilterModel>({ items: [] }); // #POW-30
  const [downloadExcelLoading, setDownloadExcelLoading] = useState(false);  // #POW-30
  const [selectedRows, setSelectedRows] = useState<GridValidRowModel[]>([]); // #POW-39 rows selected in datagrid

  useEffect(() => {
    if (isReady) {
      if (!auth.canAccessContext('pages.TransactionsSentPage')) { // #POW-22 
        navigate("/dashboard");
      }
    }
  }, [isReady]);

  // #POW-39 callback function for get data from ShopTransactionsDataGrid component
  const handleSelectedRowsChange = (rows:any) => {
    setSelectedRows(rows);
  };

  // #POW-30 callback function for get data from ShopTransactionsSentDataGrid component
  const handleFilterModelChange = (model:any) => {
    setFilterModel(model);
  }

  // #POW-30
  const exportSentTransactions = async () => {
    setDownloadExcelLoading(true); // #POW-23

    let filters: { field: string; value: string }[] = [];

    // map datagrid field names to db names
    const fieldMapping: { [key: string]: string } = {
      id: "number", // the id field is the number of transaction
      date: "transaction_date", // the transaction_date field is the date of transaction
      device_serial: "device_sn", // is our device_serial in datagrid
    };

    filterModel.items.forEach((item) => {
      const field = fieldMapping[item.field] || item.field;
      
      filters.push({'field': field, 'value': item.value});
    });

    // columns to export
    const columns: string[] = [
      'logistic_shipping_date',
      'logistic_custom_sku_transfer',
      'logistic_custom_shipping_code', 
      'number', // is our id in datagrid
      'transaction_date', // is our date in datagrid
      'type', 
      'device_name', 
      'device_imei', 
      'device_sn',  // is our device_serial in datagrid
      'grade',
      'price'
    ];

    let selectedRowsToExport: string[] = []; // #POW-39
    if(selectedRows.length > 0)  // #POW-39
    {
      selectedRows.forEach((item) => selectedRowsToExport.push(item.id));
    }

    const url = `${Config.serverUrl}/api/trade-in/transactions/excel`;
    const response = await customFetch(url, {
      method: 'POST',
      headers: {
      'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        type: 'sent',
        rows: selectedRowsToExport,  // #POW-39
        filters: filters,
        columns: columns
      }),
    });

    if (response.ok) {
      const blob = await response.blob();
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `transactions_sent.xlsx`;
      link.click();
      setDownloadExcelLoading(false);
    } else {
        console.error('Failed to download excel file');
    }

  }


  return (
    <DashboardLayout>
      <Typography component="h1" sx={{textAlign:'left', width:'100%', typography: { xs: 'h5', sm: 'h4' }}}>
        {t("sentTransactions.title")}
      </Typography>
      {/* #POW-30 */}
      <Stack direction="row" sx={{justifyContent: "end", alignItems: "center", width: '100%'}}>
        <Box sx={{ m: 1, position: 'relative' }}>
          <Button  onClick={() => {
              exportSentTransactions();
            }} 
            disabled={downloadExcelLoading}
            variant="contained" startIcon={<FileDownloadIcon />}>{t("transactions.btnExportTransactions")}
          </Button>
          {downloadExcelLoading && ( // #POW-30
              <CircularProgress
                  size={24}
                  sx={{
                  color: blue[900],
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  marginTop: '-12px',
                  marginLeft: '-12px',
                  }}
              />
          )}
        </Box>
      </Stack>
      <ShopTransactionsSentDataGrid onFilterModelChange={handleFilterModelChange} onSelectedRowsChange={handleSelectedRowsChange}/> {/* #POW-39 */}
    </DashboardLayout>
  );
};

export default TransactionsSentPage;
